import { SellerSettings } from '@api/src/models/AgentApi/Contract/seller-settings';
import { CommissionSource } from '@core/calculator/commission-source';
import { Product } from '@core/calculator/product';

export interface TotalPriceOptions {
    sellWithRegistration?: boolean;
}

export class PriceCalculator {
    readonly #price: number;
    readonly #product: Product;
    readonly #sellerSettings: SellerSettings;
    readonly #options: TotalPriceOptions;

    constructor(price: number, product: Product, sellerSettings: SellerSettings, options?: TotalPriceOptions) {
        this.#price = price;
        this.#product = product;
        this.#sellerSettings = sellerSettings;
        this.#options = options;
    }

    #getOnePercent(value: number): number {
        return value / 100;
    }

    public get totalPrice(): number {
        switch (this.#product) {
            case Product.SellProduct:
                if (this.#sellerSettings.commSource === CommissionSource.Client) {
                    return this.#price + this.#getOnePercent(this.#price) * this.#sellerSettings.saleCommPct;
                } else {
                    return this.#price;
                }

            case Product.SellCard:
                if (this.#sellerSettings.commSource === CommissionSource.Client) {
                    return (
                        this.#sellerSettings.cardPrice +
                        this.#price +
                        this.#getOnePercent(this.#sellerSettings.cardPrice) * this.#sellerSettings.saleCommPct +
                        this.#getOnePercent(this.#price) * this.#sellerSettings.payCommPct +
                        (this.#options?.sellWithRegistration
                            ? this.#sellerSettings.registerPrice +
                              this.#getOnePercent(this.#sellerSettings.registerPrice) * this.#sellerSettings.saleCommPct
                            : 0)
                    );
                } else {
                    return (
                        this.#sellerSettings.cardPrice +
                        this.#price +
                        (this.#options?.sellWithRegistration ? this.#sellerSettings.registerPrice : 0)
                    );
                }

            case Product.RegisterCard:
                if (this.#sellerSettings.commSource === CommissionSource.Client) {
                    return (
                        this.#sellerSettings.registerPrice +
                        this.#price +
                        this.#getOnePercent(this.#sellerSettings.registerPrice) * this.#sellerSettings.saleCommPct +
                        this.#getOnePercent(this.#price) * this.#sellerSettings.payCommPct
                    );
                } else {
                    return this.#sellerSettings.registerPrice + this.#price;
                }

            case Product.TopUp:
            default:
                if (this.#sellerSettings.commSource === CommissionSource.Client) {
                    return this.#price + this.#getOnePercent(this.#price) * this.#sellerSettings.payCommPct;
                } else {
                    return this.#price;
                }
        }
    }
}
